;(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn()
    } else {
      document.addEventListener('DOMContentLoaded', fn)
    }
  }
  function debounce(fn) {
    var id = 0
    return function () {
      if (id) cancelAnimationFrame(id)
      id = requestAnimationFrame(fn)
    }
  }
  function visibleColumns(section) {
    var cols = Array.prototype.slice.call(section.querySelectorAll('.fg__column'))
    return cols.filter(function (c) {
      return c.offsetParent !== null && window.getComputedStyle(c).display !== 'none'
    })
  }
  function pack(section) {
    var columns = visibleColumns(section)
    if (columns.length < 2) return
    var items = Array.prototype.slice.call(section.querySelectorAll('.footer-waterfall-gallery__item'))
    if (!items.length) return
    // sort by original index
    items.sort(function (a, b) {
      return (parseInt(a.getAttribute('data-original-index')) || 0) - (parseInt(b.getAttribute('data-original-index')) || 0)
    })
    var heights = columns.map(function () {
      return 0
    })
    columns.forEach(function (col) {
      while (col.firstChild) col.removeChild(col.firstChild)
    })
    items.forEach(function (item) {
      var minIndex = 0
      for (var i = 1; i < heights.length; i++) {
        if (heights[i] < heights[minIndex]) minIndex = i
      }
      columns[minIndex].appendChild(item)
      heights[minIndex] = columns[minIndex].scrollHeight
    })
  }
  ready(function () {
    var sections = Array.prototype.slice.call(document.querySelectorAll('.footer-waterfall-gallery[data-distribution="balanced"]'))
    if (!sections.length) return
    sections.forEach(function (section) {
      var repack = debounce(function () {
        pack(section)
      })
      repack()
      var imgs = Array.prototype.slice.call(section.querySelectorAll('img'))
      imgs.forEach(function (img) {
        if (!img.complete) img.addEventListener('load', repack, { once: true })
      })
      window.addEventListener('resize', repack)
      if (typeof ResizeObserver !== 'undefined') {
        var ro = new ResizeObserver(repack)
        ro.observe(section)
      }
    })
  })
})()
